import AffiliatesIcon from './AffiliatesIcon/AffiliatesIcon';
import BaccaratIcon from './BaccaratIcon/BaccaratIcon';
import BlackjackIcon from './BlackjackIcon/BlackjackIcon';
import CasinoClassicsIcon from './CasinoClassicsIcon/CasinoClassicsIcon';
import FantasyIcon from './FantasyIcon/FantasyIcon';
import FavoritesIcon from './FavoritesIcon/FavoritesIcon';
import GameShowsIcon from './GameShowsIcon/GameShowsIcon';
import HelpCenterIcon from './HelpCenterIcon/HelpCenterIcon';
import HomeIcon from './HomeIcon/HomeIcon';
import LiveCasinoIcon from './LiveCasinoIcon/LiveCasinoIcon';
import LiveSupportIcon from './LiveSupportIcon/LiveSupportIcon';
import OtherworldOriginalsIcon from './OtherworldOriginalsIcon/OtherworldOriginalsIcon';
import PromotionsIcon from './PromotionsIcon/PromotionsIcon';
import ProvidersIcon from './ProvidersIcon/ProvidersIcon';
import RedeemCodeIcon from './RedeemCodeIcon/RedeemCodeIcon';
import RewardsIcon from './RewardsIcon/RewardsIcon';
import RouletteIcon from './RouletteIcon/RouletteIcon';
import SettingsIcon from './SettingsIcon/SettingsIcon';

import TrendingIcon from './TrendingIcon/TrendingIcon';
import VIPLoungeIcon from './VIPLoungeIcon/VIPLoungeIcon';
import VIPRewardsIcon from './VIPRewardsIcon/VIPRewardsIcon';
import VIPStatusMatchIcon from './VIPStatusMatchIcon/VIPStatusMatchIcon';
import WalletIcon from './WalletIcon/WalletIcon';

export const sideNavIcons: SideNavIconsInterface = {
	home: HomeIcon,
	fantasy: FantasyIcon,
	otherworldoriginals: OtherworldOriginalsIcon,
	trending: TrendingIcon,
	casinoclassics: CasinoClassicsIcon,
	livecasino: LiveCasinoIcon,
	blackjack: BlackjackIcon,
	roulette: RouletteIcon,
	gameshows: GameShowsIcon,
	baccarat: BaccaratIcon,
	providers: ProvidersIcon,
	rewards: RewardsIcon,
	leveluprewards: RewardsIcon,
	promotions: PromotionsIcon,
	redeemcode: RedeemCodeIcon,
	viprewards: VIPRewardsIcon,
	viplounge: VIPLoungeIcon,
	vipstatusmatch: VIPStatusMatchIcon,
	affiliates: AffiliatesIcon,
	helpcenter: HelpCenterIcon,
	livesupport: LiveSupportIcon,
	favorites: FavoritesIcon,
	wallet: WalletIcon,
	settings: SettingsIcon,
};

export interface SideNavIconsInterface {
	home: React.FC<React.SVGProps<SVGSVGElement>>;
	fantasy: React.FC<React.SVGProps<SVGSVGElement>>;
	otherworldoriginals: React.FC<React.SVGProps<SVGSVGElement>>;
	trending: React.FC<React.SVGProps<SVGSVGElement>>;
	casinoclassics: React.FC<React.SVGProps<SVGSVGElement>>;
	livecasino: React.FC<React.SVGProps<SVGSVGElement>>;
	blackjack: React.FC<React.SVGProps<SVGSVGElement>>;
	roulette: React.FC<React.SVGProps<SVGSVGElement>>;
	gameshows: React.FC<React.SVGProps<SVGSVGElement>>;
	baccarat: React.FC<React.SVGProps<SVGSVGElement>>;
	providers: React.FC<React.SVGProps<SVGSVGElement>>;
	rewards: React.FC<React.SVGProps<SVGSVGElement>>;
	leveluprewards: React.FC<React.SVGProps<SVGSVGElement>>;
	promotions: React.FC<React.SVGProps<SVGSVGElement>>;
	redeemcode: React.FC<React.SVGProps<SVGSVGElement>>;
	viprewards: React.FC<React.SVGProps<SVGSVGElement>>;
	viplounge: React.FC<React.SVGProps<SVGSVGElement>>;
	vipstatusmatch: React.FC<React.SVGProps<SVGSVGElement>>;
	affiliates: React.FC<React.SVGProps<SVGSVGElement>>;
	helpcenter: React.FC<React.SVGProps<SVGSVGElement>>;
	livesupport: React.FC<React.SVGProps<SVGSVGElement>>;
	favorites: React.FC<React.SVGProps<SVGSVGElement>>;
	wallet: React.FC<React.SVGProps<SVGSVGElement>>;
	settings: React.FC<React.SVGProps<SVGSVGElement>>;
}
